const default_dashboards = [
    {
        "number": 1,
        "group": "Pairs",
        "sub_group": "",
        "name": "^SPX/^NDX",
        "index": "^SPX/^NDX",
        "etf": "^SPX/^NDX"
    },
    {
        "number": 2,
        "group": "Pairs",
        "sub_group": "",
        "name": "^SPX/IWM",
        "index": "^SPX/IWM",
        "etf": "^SPX/IWM"
    },
    {
        "number": 3,
        "group": "Pairs",
        "sub_group": "",
        "name": "^SPX/^STOXX",
        "index": "^SPX/^STOXX",
        "etf": "^SPX/^STOXX"
    },
    {
        "number": 4,
        "group": "Pairs",
        "sub_group": "",
        "name": "EXSE.DE/EUE.L",
        "index": "EXSE.DE/EUE.L",
        "etf": "EXSE.DE/EUE.L"
    },
    {
        "number": 5,
        "group": "Pairs",
        "sub_group": "",
        "name": "MIDD.L/ISF.L",
        "index": "MIDD.L/ISF.L",
        "etf": "MIDD.L/ISF.L"
    },
    {
        "number": 6,
        "group": "Pairs",
        "sub_group": "",
        "name": "AIM1.L/MIDD.L",
        "index": "AIM1.L/MIDD.L",
        "etf": "AIM1.L/MIDD.L"
    },
    {
        "number": 7,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^STOXX50E",
        "index": "^STOXX50E",
        "etf": "EUE.L"
    },
    {
        "number": 8,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^STOXX",
        "index": "^STOXX",
        "etf": "EXSA.DE"
    },
    {
        "number": 9,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^GDAXI",
        "index": "^GDAXI",
        "etf": "EXS1.DE"
    },
    {
        "number": 10,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^STOXX50E",
        "index": "^STOXX50E",
        "etf": "EUE.L"
    },
    {
        "number": 11,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^NQEUMC",
        "index": "^NQEUMC",
        "etf": "DJMC.L"
    },
    {
        "number": 12,
        "group": "Europe",
        "sub_group": "Index",
        "name": "YY1T.Z",
        "index": "YY1T.Z",
        "etf": "EXSE.DE"
    },
    {
        "number": 13,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^FTSE",
        "index": "^FTSE",
        "etf": "ISF.L"
    },
    {
        "number": 14,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^FTMC",
        "index": "^FTMC",
        "etf": "MIDD.L"
    },
    {
        "number": 15,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^FTAI",
        "index": "^FTAI",
        "etf": "AIM1.L"
    },
    {
        "number": 16,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^FCHI",
        "index": "^FCHI",
        "etf": "CACX.L"
    },
    {
        "number": 17,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^IBEX",
        "index": "^IBEX",
        "etf": "LYXIB.MC"
    },
    {
        "number": 18,
        "group": "Europe",
        "sub_group": "Index",
        "name": "FTSEMIB.MI",
        "index": "FTSEMIB.MI",
        "etf": "IMIB.L"
    },
    {
        "number": 19,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^OMX",
        "index": "^OMX",
        "etf": "OMXS.L"
    },
    {
        "number": 20,
        "group": "Europe",
        "sub_group": "Index",
        "name": "^MDAXI",
        "index": "^MDAXI",
        "etf": "EXS3.DE"
    },
    {
        "number": 21,
        "group": "Europe",
        "sub_group": "Index",
        "name": "FTSEMIB.MI",
        "index": "FTSEMIB.MI",
        "etf": "DBXI.DE"
    },
    {
        "number": 22,
        "group": "US",
        "sub_group": "Index",
        "name": "ES=F",
        "index": "ES=F",
        "etf": "ES=F"
    },
    {
        "number": 23,
        "group": "US",
        "sub_group": "Index",
        "name": "NQ=F",
        "index": "NQ=F",
        "etf": "NQ=F"
    },
    {
        "number": 24,
        "group": "US",
        "sub_group": "Index",
        "name": "^VIX",
        "index": "^VIX",
        "etf": "^VIX"
    },
    {
        "number": 25,
        "group": "US",
        "sub_group": "Index",
        "name": "^VVIX",
        "index": "^VVIX",
        "etf": "^VVIX"
    },
    {
        "number": 26,
        "group": "US",
        "sub_group": "Index",
        "name": "BTC=F",
        "index": "BTC=F",
        "etf": "BTC=F"
    },
    {
        "number": 27,
        "group": "Commodities",
        "sub_group": "Futures",
        "name": "CL=F",
        "index": "CL=F",
        "etf": "CL=F"
    },
    {
        "number": 28,
        "group": "Commodities",
        "sub_group": "Futures",
        "name": "QC=F",
        "index": "QC=F",
        "etf": "QC=F"
    },
    {
        "number": 29,
        "group": "Commodities",
        "sub_group": "Futures",
        "name": "GC=F",
        "index": "GC=F",
        "etf": "GC=F"
    },
    {
        "number": 30,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "GBPUSD=X",
        "index": "GBPUSD=X",
        "etf": "GBPUSD=X"
    },
    {
        "number": 31,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "EURUSD=X",
        "index": "EURUSD=X",
        "etf": "EURUSD=X"
    },
    {
        "number": 32,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "JPY=X",
        "index": "JPY=X",
        "etf": "JPY=X"
    },
    {
        "number": 33,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "USDMXN=X",
        "index": "USDMXN=X",
        "etf": "USDMXN=X"
    },
    {
        "number": 34,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "INR=X",
        "index": "INR=X",
        "etf": "INR=X"
    },
    {
        "number": 35,
        "group": "Currencies",
        "sub_group": "Main",
        "name": "GBPINR=X",
        "index": "GBPINR=X",
        "etf": "GBPINR=X"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXDP.Z",
        "index": "SXDP.Z",
        "etf": "EXV4.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXNP.Z",
        "index": "SXNP.Z",
        "etf": "EXH4.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SX3P.Z",
        "index": "SX3P.Z",
        "etf": "EXH3.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SX7P.Z",
        "index": "SX7P.Z",
        "etf": "EXV1.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SX8P.Z",
        "index": "SX8P.Z",
        "etf": "EXV3.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXQE.Z",
        "index": "SXQE.Z",
        "etf": "EXH7.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXIP.Z",
        "index": "SXIP.Z",
        "etf": "EXH5.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXEP.Z",
        "index": "SXEP.Z",
        "etf": "EXH1.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SX6P.Z",
        "index": "SX6P.Z",
        "etf": "EXH9.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "Q1Q.Z",
        "index": "Q1Q.Z",
        "etf": "EXH8.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXKP.Z",
        "index": "SXKP.Z",
        "etf": "EXV2.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXOP.Z",
        "index": "SXOP.Z",
        "etf": "EXV8.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "^127283-USD-STRD",
        "index": "^127283-USD-STRD",
        "etf": "ESIF.L"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "F1GF.Z",
        "index": "F1GF.Z",
        "etf": "EXI5.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXAP.Z",
        "index": "SXAP.Z",
        "etf": "EXV5.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "SXPP.Z",
        "index": "SXPP.Z",
        "etf": "EXV6.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "Q1G.Z",
        "index": "Q1G.Z",
        "etf": "EXV9.DE"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "34XT.Z",
        "index": "34XT.Z",
        "etf": "X7PS.L"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "^SPGTCLCN",
        "index": "^SPGTCLCN",
        "etf": "ICLN"
    },
    {
        "number": 36,
        "group": "Europe",
        "sub_group": "Sector Abs",
        "name": "^SPGLGUN",
        "index": "^SPGLGUN",
        "etf": "GLUX.MI"
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXDP.Z/STOXX",
        "index": "SXDP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXNP.Z/STOXX",
        "index": "SXNP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SX3P.Z/STOXX",
        "index": "SX3P.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SX7P.Z/STOXX",
        "index": "SX7P.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SX8P.Z/STOXX",
        "index": "SX8P.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXQE.Z/STOXX",
        "index": "SXQE.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXIP.Z/STOXX",
        "index": "SXIP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXEP.Z/STOXX",
        "index": "SXEP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SX6P.Z/STOXX",
        "index": "SX6P.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "Q1Q.Z/STOXX",
        "index": "Q1Q.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXKP.Z/STOXX",
        "index": "SXKP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXOP.Z/STOXX",
        "index": "SXOP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "^127283-USD-STRD/STOXX",
        "index": "^127283-USD-STRD/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "F1GF.Z/STOXX",
        "index": "F1GF.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXAP.Z/STOXX",
        "index": "SXAP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "SXPP.Z/STOXX",
        "index": "SXPP.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "Q1G.Z/STOXX",
        "index": "Q1G.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "34XT.Z/STOXX",
        "index": "34XT.Z/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "ICLN/STOXX",
        "index": "ICLN/STOXX",
        "etf": ""
    },
    {
        "number": 37,
        "group": "Europe",
        "sub_group": "Sector Rel",
        "name": "GLUX.MI/STOXX",
        "index": "GLUX.MI/STOXX",
        "etf": ""
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705382-EUR-STRD",
        "index": "^705382-EUR-STRD",
        "etf": "IEVL.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^703764-EUR-STRD",
        "index": "^703764-EUR-STRD",
        "etf": "IEFM.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^713283-USD-STRD",
        "index": "^713283-USD-STRD",
        "etf": "EQDSL.XC"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705880-EUR-STRD",
        "index": "^705880-EUR-STRD",
        "etf": "IEFS.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^146457-EUR-STRD",
        "index": "^146457-EUR-STRD",
        "etf": "IMV.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^EFV-IV",
        "index": "^EFV-IV",
        "etf": "IWVG.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^703764-EUR-STRD",
        "index": "^703764-EUR-STRD",
        "etf": "IEFM.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^709433-USD-STRD",
        "index": "^709433-USD-STRD",
        "etf": "MINV.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705169-USD-GRTR",
        "index": "^705169-USD-GRTR",
        "etf": "IWQU.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "GPVAN001.FGI",
        "index": "GPVAN001.FGI",
        "etf": "VHYG.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^PUTVM",
        "index": "^PUTVM",
        "etf": "MVUS.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705911-USD-STRD",
        "index": "^705911-USD-STRD",
        "etf": "IUQD.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705284-USD-STRD",
        "index": "^705284-USD-STRD",
        "etf": "IUSF.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^705043-USD-STRD",
        "index": "^705043-USD-STRD",
        "etf": "IWFS.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^139249-USD-STRD",
        "index": "^139249-USD-STRD",
        "etf": "USSC.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "FDXKJDMN.FGI",
        "index": "FDXKJDMN.FGI",
        "etf": "VEVE.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^703454-USD-NETR",
        "index": "^703454-USD-NETR",
        "etf": "XDEV.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^703025-USD-STRD",
        "index": "^703025-USD-STRD",
        "etf": "IUMF.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^720344-USD-STRD",
        "index": "^720344-USD-STRD",
        "etf": "IUVF.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^RLG",
        "index": "^RLG",
        "etf": "RSGL.L"
    },
    {
        "number": 38,
        "group": "ETFs",
        "sub_group": "Factor",
        "name": "^RLG",
        "index": "^RLG",
        "etf": "RSGL.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^GSPC",
        "index": "^GSPC",
        "etf": "SPY"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^NDX",
        "index": "^NDX",
        "etf": "EQQQ.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^SP400",
        "index": "^SP400",
        "etf": "SPY4.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^RUTTR",
        "index": "^RUTTR",
        "etf": "RTYS.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^IXIC",
        "index": "^IXIC",
        "etf": "QQQ3.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^SP500TR",
        "index": "^SP500TR",
        "etf": "3LUS.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "Factors",
        "name": "^SP500TR",
        "index": "^SP500TR",
        "etf": "XS2D.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "N/A",
        "index": "N/A",
        "etf": "XSPS.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "N/A",
        "index": "N/A",
        "etf": "XT2D.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^SP600",
        "index": "^SP600",
        "etf": "ISP6.L"
    },
    {
        "number": 39,
        "group": "ETFs",
        "sub_group": "US Indices",
        "name": "^SPX",
        "index": "^SPX",
        "etf": "IUSA.L"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SPSIAD",
        "index": "^SPSIAD",
        "etf": "XAR"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SPSIBK",
        "index": "^SPSIBK",
        "etf": "KBE"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^IXCTR",
        "index": "^IXCTR",
        "etf": "XLC"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^IXY",
        "index": "^IXY",
        "etf": "XLY"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^IXR",
        "index": "^IXR",
        "etf": "XLP"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^IXE",
        "index": "^IXE",
        "etf": "XLE"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-40",
        "index": "^SP500-40",
        "etf": "XLF"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-35",
        "index": "^SP500-35",
        "etf": "XLV"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-20",
        "index": "^SP500-20",
        "etf": "XLI"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-15",
        "index": "^SP500-15",
        "etf": "XLB"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SPSIOP",
        "index": "^SPSIOP",
        "etf": "XOP"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-60",
        "index": "^SP500-60",
        "etf": "XLRE"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-45",
        "index": "^SP500-45",
        "etf": "XLK"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^SP500-55",
        "index": "^SP500-55",
        "etf": "XLU"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^NBI",
        "index": "^NBI",
        "etf": "IBB"
    },
    {
        "number": 39,
        "group": "US",
        "sub_group": "Sector Abs",
        "name": "^GSOX",
        "index": "^GSOX",
        "etf": "HNSS.L"
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XAR/SPY",
        "index": "XAR/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "KBE/SPY",
        "index": "KBE/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLC/SPY",
        "index": "XLC/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLY/SPY",
        "index": "XLY/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLP/SPY",
        "index": "XLP/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLE/SPY",
        "index": "XLE/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLF/SPY",
        "index": "XLF/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLV/SPY",
        "index": "XLV/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLI/SPY",
        "index": "XLI/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLB/SPY",
        "index": "XLB/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XOP/SPY",
        "index": "XOP/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLRE/SPY",
        "index": "XLRE/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLK/SPY",
        "index": "XLK/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "XLU/SPY",
        "index": "XLU/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "IBB/SPY",
        "index": "IBB/SPY",
        "etf": ""
    },
    {
        "number": 40,
        "group": "US",
        "sub_group": "Sector Rel",
        "name": "HNSS.L/SPY",
        "index": "HNSS.L/SPY",
        "etf": ""
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "UTEN",
        "index": "UTEN",
        "etf": "UTEN"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "UTHY",
        "index": "UTHY",
        "etf": "UTHY"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "UTWO",
        "index": "UTWO",
        "etf": "UTWO"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "IGLS.L",
        "index": "IGLS.L",
        "etf": "IGLS.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "IGLT.L",
        "index": "IGLT.L",
        "etf": "IGLT.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "0P0001F9UG.L",
        "index": "0P0001F9UG.L",
        "etf": "AGGG.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "0P00015M16",
        "index": "0P00015M16",
        "etf": "VBIRX"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "TWE=F",
        "index": "TWE=F",
        "etf": "IBTL.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "^IDCOT7TR",
        "index": "^IDCOT7TR",
        "etf": "CBU0.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "^IDCOT1TR",
        "index": "^IDCOT1TR",
        "etf": "CBU3.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "^IDCOTCTR",
        "index": "^IDCOTCTR",
        "etf": "GOVP.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Rates",
        "name": "^STPZ-IV",
        "index": "^STPZ-IV",
        "etf": "ITPS.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "GC=F",
        "index": "GC=F",
        "etf": "PHGP.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "SI=F",
        "index": "SI=F",
        "etf": "PHAG.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "^DJCB-IV",
        "index": "^DJCB-IV",
        "etf": "CMOD.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "PL=F",
        "index": "PL=F",
        "etf": "SPLT.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "GC=F",
        "index": "GC=F",
        "etf": "SGLN.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "NG=F",
        "index": "NG=F",
        "etf": "NGSP.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "CL=F",
        "index": "CL=F",
        "etf": "BRNB.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "^DBOLIX",
        "index": "^DBOLIX",
        "etf": "LOIL.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Asia",
        "name": "^N225",
        "index": "^N225",
        "etf": "CNKY.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Asia",
        "name": "^915800-USD-STRD",
        "index": "^915800-USD-STRD",
        "etf": "HTWN.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Asia",
        "name": "^730535-USD-STRD",
        "index": "^730535-USD-STRD",
        "etf": "HKOR.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "^GDMNTR",
        "index": "^GDMNTR",
        "etf": "GDX"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Commodities",
        "name": "^GDXJ-NV",
        "index": "^GDXJ-NV",
        "etf": "GDXJ"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Credit",
        "name": "VBMFX",
        "index": "VBMFX",
        "etf": "IHHG.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Credit",
        "name": "VBMFX",
        "index": "VBMFX",
        "etf": "CRHG.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^907600-USD-STRD",
        "index": "^907600-USD-STRD",
        "etf": "IBZL.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^NSEI",
        "index": "^NSEI",
        "etf": "XNIF.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^700663-USD-STRD",
        "index": "^700663-USD-STRD",
        "etf": "CMX1.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^EMX",
        "index": "^EMX",
        "etf": "EMRD.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^EMX",
        "index": "^EMX",
        "etf": "EEM"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "^EMX",
        "index": "^EMX",
        "etf": "IEMG"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "AWALLEN.FGI",
        "index": "AWALLEN.FGI",
        "etf": "VFEM.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "N/A",
        "index": "N/A",
        "etf": "0P00017V11.L"
    },
    {
        "number": 41,
        "group": "ETFs",
        "sub_group": "Emerging Markets",
        "name": "N/A",
        "index": "N/A",
        "etf": "IIND.L"
    }
];

const indian_export = [
    {
        "number": 2,
        "group": "Indices",
        "sub_group": "",
        "name": "Indian Nifty",
        "index": "^NSEI",
        "etf": "^NSEI"
    },
    {
        "number": 3,
        "group": "Indices",
        "sub_group": "",
        "name": "Bank Nifty",
        "index": "^NSEBANK",
        "etf": "^NSEBANK"
    },
    {
        "number": 5,
        "group": "Indices",
        "sub_group": "",
        "name": "Sensex",
        "index": "^BSESN",
        "etf": "^BSESN"
    },
    {
        "number": 6,
        "group": "Indices",
        "sub_group": "",
        "name": "Dow Jones",
        "index": "^DJI",
        "etf": "^DJI"
    }
];



export function getDashboards(offset=0, count=10) {
  const dataPromise = new Promise((resolve, reject) => {
    // Simulating an asynchronous operation (e.g., fetching data from an API)
    setTimeout(() => {
      const dummyData = indian_export.slice(offset, offset + count);
      console.log(dummyData);
      resolve({
        "data": dummyData,
        "total": indian_export.length
      });
    }, 1000); // Simulating a 1-second delay, replace with your actual async operation time
  });
  return dataPromise;
}
